<app-gmao-spinner *ngIf="!searchResults"></app-gmao-spinner>
<ng-container *ngIf="searchResults">
    <pagination-controls class="custom-pagination" style="text-align: center;" (pageChange)="pageChange($event)" previousLabel="Précédent" nextLabel="Suivant"></pagination-controls>
    <p>{{nbsearchResults}} résultats</p>
    <div class="wrapper shadowed" *ngFor="let result of searchResults.results| paginate : {  itemsPerPage: 30,
        currentPage: p,
        totalItems: nbsearchResults }">
        <p class="onHover" (click)="onClickResult(result.type,result.url)"><span class="material-icons">{{result.maticon}}</span>{{result.nom}}</p>
    </div>
   
</ng-container>
